import angular from 'angular';

const config = {
    apiUrl: '/api',
    imagesUrl: '',
    minColorSearchLength: 2,

    boxes: [{
            name: 'SERIES',
            defaultSelectedIdFieldName: 'series',
            subtitle: 'Serie',
            type: 'series',
            modalTitle: 'Serie',
            active: true,
            partType: 'series',
            productTypes: [
                'folding_door',
                'window',
                'door',
                'roof_window',
                'roller_blind',
                'internal_blind',
                'plisse',
                'vertical_blind',
            ]
        },
        {
            name: 'GLAZING',
            defaultSelectedIdFieldName: 'glazing',
            subtitle: 'GLAZING',
            type: 'glazing',
            modalTitle: 'GLAZING',
            active: true,
            partType: 'glazing',
            productTypes: [
                'folding_door',
                'window',
                'roof_window',
            ]
        },
        {
            name: 'GLASS',
            type: 'ornament',
            defaultSelectedIdFieldName: 'ornament',
            subtitle: 'GLASS',
            modalTitle: 'GLASS',
            active: true,
            partType: 'glass',
            productTypes: [
                'folding_door',
                'window',
                'roof_window',
            ]
        },
        {
            name: 'PACKETS',
            type: 'packet',
            defaultSelectedIdFieldName: 'packet',
            subtitle: 'PACKET',
            modalTitle: 'PACKET',
            active: true,
            partType: 'packet',
            productTypes: [
                'folding_door',
                'window',
                'roof_window',
            ]
        },
        {
            name: 'HANDLES',
            type: 'handle',
            defaultSelectedIdFieldName: 'handleInside',
            subtitle: 'HANDLES',
            modalTitle: 'HANDLES',
            active: true,
            partType: 'handle',
            productTypes: [
                'folding_door',
                'window',
                'door',
                'roof_window',
            ]
        },
        {
            name: 'COLOR',
            type: 'color',
            defaultSelectedIdFieldName: 'inner',
            subtitle: 'COLOR',
            modalTitle: 'COLOR',
            active: true,
            partType: 'color',
            productTypes: [
                'folding_door',
                'window',
                'roof_window',
            ]
        },
        {
            name: 'MULLIONS_N_DIVIDERS',
            type: 'sash',
            defaultSelectedIdFieldName: 'sash',
            subtitle: 'MULLIONS_N_DIVIDERS',
            modalTitle: 'MULLIONS_N_DIVIDERS',
            active: true,
            partType: 'sash',
            productTypes: [
                'folding_door',
                'window',
            ]
        },
        {
            name: 'CONTROL_SIDE',
            type: 'rollerBlindControlSides',
            defaultSelectedIdFieldName: 'rollerBlindControlSide',
            subtitle: 'CONTROL_SIDE',
            modalTitle: 'CONTROL_SIDE',
            active: true,
            partType: 'rollerBlindControlSides',
            productTypes: [
                'roller_blind',
            ]
        },
        {
            name: 'BOX',
            type: 'rollerBlindBoxes',
            defaultSelectedIdFieldName: 'rollerBlindBox',
            subtitle: 'BOX',
            modalTitle: 'BOX',
            active: true,
            partType: 'rollerBlindBoxes',
            productTypes: [
                'roller_blind',
            ]
        },
        {
            name: 'FABRIC',
            type: 'rollerBlindFabrics',
            defaultSelectedIdFieldName: 'rollerBlindFabric',
            subtitle: 'FABRIC',
            modalTitle: 'FABRIC',
            active: true,
            partType: 'rollerBlindFabrics',
            productTypes: [
                'roller_blind',
            ]
        },
        {
            name: 'CONTROL_SIDE',
            type: 'internalBlindControlSides',
            defaultSelectedIdFieldName: 'internalBlindControlSide',
            subtitle: 'CONTROL_SIDE',
            modalTitle: 'CONTROL_SIDE',
            active: true,
            partType: 'internalBlindControlSides',
            productTypes: [
                'internal_blind',
            ]
        },
        {
            name: 'TOP_RAIL',
            type: 'internalBlindTopRails',
            defaultSelectedIdFieldName: 'internalBlindTopRail',
            subtitle: 'TOP_RAIL',
            modalTitle: 'TOP_RAIL',
            active: true,
            partType: 'internalBlindTopRails',
            productTypes: [
                'internal_blind',
            ]
        },
        {
            name: 'LOUVRE',
            type: 'internalBlindLouvres',
            defaultSelectedIdFieldName: 'internalBlindLouvre',
            subtitle: 'LOUVRE',
            modalTitle: 'LOUVRE',
            active: true,
            partType: 'internalBlindLouvres',
            productTypes: [
                'internal_blind',
            ]
        },
        {
            name: 'BOTTOM_RAIL',
            type: 'internalBlindBottomRails',
            defaultSelectedIdFieldName: 'internalBlindBottomRail',
            subtitle: 'BOTTOM_RAIL',
            modalTitle: 'BOTTOM_RAIL',
            active: true,
            partType: 'internalBlindBottomRails',
            productTypes: [
                'internal_blind',
            ]
        },
        {
            name: 'LATH',
            type: 'plisseRails',
            defaultSelectedIdFieldName: 'plisseRail',
            subtitle: 'LATH',
            modalTitle: 'LATH',
            active: true,
            partType: 'plisseRails',
            productTypes: [
                'plisse',
            ]
        },
        {
            name: 'SHEATING',
            type: 'plisseSheatings',
            defaultSelectedIdFieldName: 'plisseSheating',
            subtitle: 'SHEATINGS',
            modalTitle: 'SHEATINGS',
            active: true,
            partType: 'plisseSheatings',
            productTypes: [
                'plisse',
            ]
        },
        {
            name: 'MONTAGE_TYPE',
            type: 'plisseMontageTypes',
            defaultSelectedIdFieldName: 'plisseMontageType',
            subtitle: 'MONTAGE_TYPE',
            modalTitle: 'MONTAGE_TYPE',
            active: true,
            partType: 'plisseMontageTypes',
            productTypes: [
                'plisse',
            ]
        },
        {
            name: 'DRIVE',
            type: 'plisseDrives',
            defaultSelectedIdFieldName: 'plisseDrive',
            subtitle: 'DRIVE',
            modalTitle: 'DRIVE',
            active: true,
            partType: 'plisseDrives',
            productTypes: [
                'plisse',
            ]
        },
        {
            name: 'CONTROL_SIDE',
            type: 'verticalBlindControlSides',
            defaultSelectedIdFieldName: 'verticalBlindControlSide',
            subtitle: 'CONTROL_SIDE',
            modalTitle: 'CONTROL_SIDE',
            active: true,
            partType: 'verticalBlindControlSides',
            productTypes: [
                'vertical_blind',
            ]
        },
        {
            name: 'STACKING_TYPE',
            type: 'verticalBlindStackingTypes',
            defaultSelectedIdFieldName: 'verticalBlindStackingType',
            subtitle: 'STACKING_TYPE',
            modalTitle: 'STACKING_TYPE',
            active: true,
            partType: 'verticalBlindStackingTypes',
            productTypes: [
                'vertical_blind',
            ]
        },
        {
            name: 'TOP_RAIL',
            type: 'verticalBlindTopRails',
            defaultSelectedIdFieldName: 'verticalBlindTopRail',
            subtitle: 'TOP_RAIL',
            modalTitle: 'TOP_RAIL',
            active: true,
            partType: 'verticalBlindTopRails',
            productTypes: [
                'vertical_blind',
            ]
        },
        {
            name: 'LOUVRE',
            type: 'verticalBlindLouvres',
            defaultSelectedIdFieldName: 'verticalBlindLouvre',
            subtitle: 'LOUVRE',
            modalTitle: 'LOUVRE',
            active: true,
            partType: 'verticalBlindLouvres',
            productTypes: [
                'vertical_blind',
            ]
        },
        {
            name: 'CHAIN',
            type: 'verticalBlindChains',
            defaultSelectedIdFieldName: 'verticalBlindChain',
            subtitle: 'CHAIN',
            modalTitle: 'CHAIN',
            active: true,
            partType: 'verticalBlindChains',
            productTypes: [
                'vertical_blind',
            ]
        },
        {
            name: 'MONTAGE_TYPE',
            type: 'verticalBlindMontageTypes',
            defaultSelectedIdFieldName: 'verticalBlindMontageType',
            subtitle: 'MONTAGE_TYPE',
            modalTitle: 'MONTAGE_TYPE',
            active: true,
            partType: 'verticalBlindMontageTypes',
            productTypes: [
                'vertical_blind',
            ]
        },
        {
            name: 'ACCESSORY',
            type: 'accessory',
            defaultSelectedIdFieldName: 'accessories',
            subtitle: 'ACCESSORIES',
            modalTitle: 'ACCESSORY',
            active: true,
            partType: 'accessory',
            productTypes: [
                'folding_door',
                'window',
                'door',
                'roof_window',
                'roller_blind',
                'internal_blind',
                'plisse',
                'vertical_blind',
            ]
        },
    ],

    jsonConfig: {
        warmEdgeId: 32,
        normalEdgeId: 33,
        default: {
            $version: 4,
            type: 'window',
            quantity: 1,
            title: '',
            height: 1500,
            width: 1500,
            wood: null,
            hasAlushell: false,
            sideAccessories: {},
            fitting: {
                id: 8888
            },
            frame: {
                id: 8888
            }
        },
        shape: {
            h1: 0,
            h2: 0,
            h3: 0,
            s1: 0,
            s2: 0,
            s3: 0,
            d: 0,
            shape: 'rect',
            type: null,
        },
        nearDividers: {
            bottom: -1,
            left: -1,
            right: -1,
            top: -1,
        },
        color: {
            RAL: false,
            isDefault: false,
        },
        dividerId: 999,
        intSash: {
            width: 0,
            height: 0,
            filling: {
                id: 123
            }
        },
        defaultSash: {
            hardware: [],
            intDividers: [],
            intSashes: [],
            filling: {
                id: 0
            }
        },
        defaultIntSash: {
            id: 0,
            parentId: 0,
            nearDividers: {
                bottom: -1,
                left: -1,
                right: -1,
                top: -1
            },
            filling: {
                id: 12
            }
        },
        muntins: {
            horizontal: [],
            vertical: []
        },
        bottomPannelFilling: {
            id: -1,
            type: 'pvc_panels',
        },
        bottomPannelDividerId: 40101,
        muntinsInfo: {
            duplex: false,
            type: {
                id: 4
            }
        }
    },
    sashTypes: {
        F: 1,
        FF: 2,
        K: {
            T: 3
        },
        DK: {
            L: 5,
            R: 11
        },
        D: {
            L: 4,
            R: 10
        },
        DS: {
            L: 18,
            R: 17
        },
        PSK: {
            L: 23,
            R: 24
        },
        HS: {
            L: 28,
            R: 25
        },
        DRA: {
            L: 32,
            R: 33
        },
        DRP: {
            L: 35,
            R: 34
        },
        SWH: {
            L: 37,
            R: 36
        },
    },
    glazingGlass: [{
            type: 'glazingGlass',
            id: '1',
            attributes: {
                placement: 'inside',
                label: 'INISDE_GLASS'
            }
        },
        {
            type: 'glazingGlass',
            id: '2',
            attributes: {
                placement: 'outside',
                label: 'OUTISDE_GLASS'
            }
        }
    ],
    defaultPacket: {
        type: 'packet',
        id: -1,
        attributes: {
            name: 'DEFAULT_PACKET',
            price: 0,
        },
        relationships: {}
    },
    shapes: {
        polygon: [{
                id: 'SLT',
                img: 'slt.png',
                default: false,
            },
            {
                id: 'SRT',
                img: 'srt.png',
                default: true,
            },
            {
                id: 'SLS',
                img: 'sls.png',
                default: false,
            },
            {
                id: 'SRS',
                img: 'srs.png',
                default: false,
            },
            {
                id: 'SLC',
                img: 'slc.png',
                default: false,
            },
            {
                id: 'SRC',
                img: 'src.png',
                default: false,
            },
            {
                id: 'DLT',
                img: 'dlt.png',
                default: false,
            },
            {
                id: 'DLS',
                img: 'dls.png',
                default: false,
            },
            {
                id: 'DLC',
                img: 'dlc.png',
                default: false,
            }
        ]
    }
};

export default angular.module('config', [])
    .constant('config', config)
    .name;
